import { render } from "./CreateFD.vue?vue&type=template&id=5b33d22c"
import script from "./CreateFD.vue?vue&type=script&lang=js"
export * from "./CreateFD.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__